import { SetLabelStrategy } from "@octopusdeploy/design-system-octopus-components";
import type * as React from "react";
interface AdvancedFiltersProps {
    children: React.ReactNode;
}
const labelStrategy = (fieldName: string) => `By ${fieldName}`;
export function AdvancedFilters({ children }: AdvancedFiltersProps) {
    return <SetLabelStrategy labelStrategy={labelStrategy}>{children}</SetLabelStrategy>;
}
